"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _part = _interopRequireDefault(require("../utils/part"));

var _notExitstsToQuery = _interopRequireDefault(require("./notExitstsToQuery"));

/**
 * Vrati query part, ktery najde vsechny zaznamy, kde neexistuje hodnota u uvedeneho pole, nebo je hodnota shodna
 * se zadanou.
 *
 * @param {string} fieldName
 * @param {*} value
 */
var equalNullableToQuery = function equalNullableToQuery(fieldName, value) {
  return value === undefined ? undefined : {
    $or: [(0, _notExitstsToQuery.default)(fieldName), (0, _part.default)(fieldName, value)]
  };
};

var _default = equalNullableToQuery;
exports.default = _default;